import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStepOverseasMedical = (state) => state.get('stepOverseasMedical');

const makeSelectStepOverseasMedical = () =>
  createSelector(selectStepOverseasMedical, (stepOverseasMedicalState) => ({
    areYouClaimingForOverseasEmergencyMedicalOrDentalExpenses: mapWithDefault(
      stepOverseasMedicalState,
      () =>
        stepOverseasMedicalState.getIn([
          'form',
          'areYouClaimingForOverseasEmergencyMedicalOrDentalExpenses',
        ]),
      ''
    ),
    areYouClaimingForOverseas247: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'areYouClaimingForOverseas247']),
      ''
    ),
    areYouClaimingForEmergencyMedicalAndHospitalExpenses: mapWithDefault(
      stepOverseasMedicalState,
      () =>
        stepOverseasMedicalState.getIn([
          'form',
          'areYouClaimingForEmergencyMedicalAndHospitalExpenses',
        ]),
      ''
    ),
    areYouClaimingForEmergencyDental: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'areYouClaimingForEmergencyDental']),
      ''
    ),
    areYouClaimingForEmergencyEvacuation: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'areYouClaimingForEmergencyEvacuation']),
      ''
    ),
    areYouClaimingForHospitalCashPayment: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'areYouClaimingForHospitalCashPayment']),
      ''
    ),
    areYouClaimingForAccidentalDeath: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'areYouClaimingForAccidentalDeath']),
      ''
    ),
    areYouClaimingForPermanentDisability: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'areYouClaimingForPermanentDisability']),
      ''
    ),
    areYouClaimingForLossOfIncome: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'areYouClaimingForLossOfIncome']),
      ''
    ),
    patientName: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'patientName']),
      ''
    ),
    relationshipToYou: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'relationshipToYou']),
      ''
    ),
    patientDateOfBirth: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'patientDateOfBirth']),
      ''
    ),
    medicareNumber: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'medicareNumber']),
      ''
    ),
    whatIsYourInjuryOrIllness: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'whatIsYourInjuryOrIllness']),
      ''
    ),
    didThisOccurWhilstEngagingInSnowSportActivity: mapWithDefault(
      stepOverseasMedicalState,
      () =>
        stepOverseasMedicalState.getIn([
          'form',
          'didThisOccurWhilstEngagingInSnowSportActivity',
        ]),
      ''
    ),
    wasTheInufredIllTravallerAnInpatient: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'wasTheInufredIllTravallerAnInpatient']),
      ''
    ),
    dateOfAdmission: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'dateOfAdmission']),
      ''
    ),
    timeOfAdmission: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'timeOfAdmission']),
      ''
    ),
    dateOfDischarge: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'dateOfDischarge']),
      ''
    ),
    timeOfDischarge: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'timeOfDischarge']),
      ''
    ),
    contactEmergencyAssistance: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'contactEmergencyAssistance']),
      ''
    ),
    assistanceCaseReferenceNumber: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'assistanceCaseReferenceNumber']),
      ''
    ),
    dateOfFirstMedicalConsultation: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'dateOfFirstMedicalConsultation']),
      ''
    ),
    hasInjuredOrIllTravellerPreviously: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'hasInjuredOrIllTravellerPreviously']),
      ''
    ),
    medicalExpenses: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'medicalExpenses']).toJS(),
      ''
    ),
    awareOfAnyMedicalConditions: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'awareOfAnyMedicalConditions']),
      ''
    ),
    underInvestigation: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'underInvestigation']),
      ''
    ),
    haveMedicalConditionOrComplication: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'haveMedicalConditionOrComplication']),
      ''
    ),
    giveATerminalPrognosis: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'giveATerminalPrognosis']),
      ''
    ),
    travellingAgainst: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'travellingAgainst']),
      ''
    ),
    previousMedicalConditionDetails: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'previousMedicalConditionDetails']),
      ''
    ),
    plannedReturnToWorkDate: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'plannedReturnToWorkDate']),
      ''
    ),
    actualReturnToWorkDate: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'actualReturnToWorkDate']),
      ''
    ),
    incomeLost: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'incomeLost']),
      ''
    ),
    insuredName: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'insuredName']),
      ''
    ),
    insuredDateOfDeath: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'insuredDateOfDeath']),
      ''
    ),
    relationshipToYouAD: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'relationshipToYouAD']),
      ''
    ),
    whatIsYourInjuryOrIllnessAD: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'whatIsYourInjuryOrIllnessAD']),
      ''
    ),
    didThisOccurWhilstEngagingInSnowSportActivityAD: mapWithDefault(
      stepOverseasMedicalState,
      () =>
        stepOverseasMedicalState.getIn([
          'form',
          'didThisOccurWhilstEngagingInSnowSportActivityAD',
        ]),
      ''
    ),
    wasTheInufredIllTravallerAnInpatientAD: mapWithDefault(
      stepOverseasMedicalState,
      () =>
        stepOverseasMedicalState.getIn(['form', 'wasTheInufredIllTravallerAnInpatientAD']),
      ''
    ),
    dateOfAdmissionAD: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'dateOfAdmissionAD']),
      ''
    ),
    timeOfAdmissionAD: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'timeOfAdmissionAD']),
      ''
    ),
    dateOfDischargeAD: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'dateOfDischargeAD']),
      ''
    ),
    timeOfDischargeAD: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'timeOfDischargeAD']),
      ''
    ),
    nameOfPractitionerDentistHospitalAD: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'nameOfPractitionerDentistHospitalAD']),
      ''
    ),
    contactEmergencyAssistanceAD: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'contactEmergencyAssistanceAD']),
      ''
    ),
    assistanceCaseReferenceNumberAD: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'assistanceCaseReferenceNumberAD']),
      ''
    ),
    dateOfFirstMedicalConsultationAD: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'dateOfFirstMedicalConsultationAD']),
      ''
    ),
    patientNameLI: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'patientNameLI']),
      ''
    ),
    relationshipToYouLI: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'relationshipToYouLI']),
      ''
    ),
    patientDateOfBirthLI: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'patientDateOfBirthLI']),
      ''
    ),
    medicareNumberLI: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'medicareNumberLI']),
      ''
    ),
    whatIsYourInjuryOrIllnessLI: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'whatIsYourInjuryOrIllnessLI']),
      ''
    ),
    didThisOccurWhilstEngagingInSnowSportActivityLI: mapWithDefault(
      stepOverseasMedicalState,
      () =>
        stepOverseasMedicalState.getIn([
          'form',
          'didThisOccurWhilstEngagingInSnowSportActivityLI',
        ]),
      ''
    ),
    wasTheInufredIllTravallerAnInpatientLI: mapWithDefault(
      stepOverseasMedicalState,
      () =>
        stepOverseasMedicalState.getIn(['form', 'wasTheInufredIllTravallerAnInpatientLI']),
      ''
    ),
    dateOfAdmissionLI: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'dateOfAdmissionLI']),
      ''
    ),
    timeOfAdmissionLI: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'timeOfAdmissionLI']),
      ''
    ),
    dateOfDischargeLI: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'dateOfDischargeLI']),
      ''
    ),
    timeOfDischargeLI: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'timeOfDischargeLI']),
      ''
    ),
    nameOfPractitionerDentistHospitalLI: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'nameOfPractitionerDentistHospitalLI']),
      ''
    ),
    contactEmergencyAssistanceLI: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'contactEmergencyAssistanceLI']),
      ''
    ),
    assistanceCaseReferenceNumberLI: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'assistanceCaseReferenceNumberLI']),
      ''
    ),
    dateOfFirstMedicalConsultationLI: mapWithDefault(
      stepOverseasMedicalState,
      () => stepOverseasMedicalState.getIn(['form', 'dateOfFirstMedicalConsultationLI']),
      ''
    ),
  }));

const makeSelectStepOverseasMedicalErrors = () =>
  createSelector(selectStepOverseasMedical, (state) => state.get('errors'));

export { makeSelectStepOverseasMedical, makeSelectStepOverseasMedicalErrors };



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepOverseasMedical/selectors.js